import React from 'react';

import { FormattedString } from '../../types';
import { RCFormGroupAlertText } from '../RCFormGroup';

/** props that form elements typically pass through */
export interface CheckableLabelProps {
  /** Main label text (or more complex components if you really need to) */
  label: FormattedString;

  /** Additional line of text below main label text children */
  sublabel?: string;

  /** Validation error message */
  errorText?: string;
}

type Props = CheckableLabelProps & {
  /** ID of element that this is the label for */
  for: string;
};

export function RCCheckableLabel(props: Props) {
  return (
    <label
      className="rc-checkable-label"
      htmlFor={props.for}
    >
      {props.label}
      {props.sublabel && (
        <span className="rc-checkable-label__sublabel">
          {props.sublabel}
        </span>
      )}
      {props.errorText && (
        <RCFormGroupAlertText errorText={props.errorText} />
      )}
    </label>
  );
}
